import React from 'react';
import { Heart } from 'lucide-react';

const MenuFooter = () => {
    return (
        <div className="mt-4 p-4 bg-gradient-to-br from-primary/20 to-primary/10 rounded-xl border border-primary/30">
            <div className="text-center mb-3">
                <div className="flex items-center justify-center gap-2 text-primary mb-1">
                    <Heart size={16} fill="currentColor" />
                    <span className="text-sm font-bold">Enjoying Keyer's Journey?</span>
                </div>
                <p className="text-xs text-muted">This app is 100% free. Support development to help keep it that way!</p>
            </div>
            <div className="flex gap-2">
                <a
                    href="https://ko-fi.com/w0ht73"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex-1 flex items-center justify-center gap-2 bg-primary hover:brightness-110 text-primary-content font-semibold py-2 px-3 rounded-lg transition-all text-sm"
                >
                    <Heart size={14} fill="currentColor" />
                    Donate on Ko-fi
                </a>
            </div>
            <div className="mt-4 pt-3 border-t border-primary/10 text-center">
                <p className="text-[10px] text-muted/70 tracking-tight italic">v1.26 • All core features will always be free • No ads ever</p>
            </div>
        </div>
    );
};

export default MenuFooter;
